export default "__VITE_ASSET__DtrRfpZK__"